<template>
	<div class="language-selector" v-if="langData.length">
		<template v-for="(language, index) in sortedLanguages" :key="index">
			<span v-if="language.isCurrentPage">{{ language.name }}</span>
			<a v-else :href="language.url" v-metric="{ module: language.omniModule }" class="related-language">
				{{ language.name }}
			</a>
		</template>
	</div>
</template>
<script>
import useStore from "webmd-cms-store/src/store";
export default {
	name: "WebMdLanguageToggle",
	data() {
		return {
			pagelang: "",
			langData: "",
		};
	},
	components: {},
	props: {
		pageData: {
			type: Array,
			default() {
				return [];
			},
		},
		isMultilingual: { type: Boolean, required: false, default: undefined },
	},
	computed: {
		getPageLang() {
			const langCode = this.store.pagedata.omniture.s_language_locale;
			if (langCode) {
				return this.updateLanguageName(langCode);
			}
			return "";
		},
		sortedLanguages() {
			// Create array with current page language
			const currentLang = {
				name: this.pagelang,
				isCurrentPage: true,
			};

			// Create array with other languages
			const otherLangs = this.langData.map((lang) => ({
				...lang,
				isCurrentPage: false,
			}));

			// Combine and sort all languages
			const allLangs = [currentLang, ...otherLangs].filter(
				(lang) => lang.name
			);

			return allLangs.sort((a, b) => {
				const nameA = a.name || "";
				const nameB = b.name || "";
				return nameA.localeCompare(nameB, undefined, {
					sensitivity: "base",
				});
			});
		},
	},
	methods: {
		getassetrelation() {
			const assetrelationsData = this.store?.pagedata?.assetrelations;

			if (!assetrelationsData || !assetrelationsData.length) {
				return [];
			}

			return assetrelationsData
				.filter(
					(item) =>
						item.relation_type_of_asset === "Language Rendition" &&
						item.relation_asset_url
				)
				.map((link) => ({
					name: link.related_asset_language_val
						? this.updateLanguageName(
							link.related_asset_language_val.trim()
						)
						: "",
					url: link.relation_asset_url
						? this.addProtocolIfMissing(link.relation_asset_url)
						: "",
					iso: link.related_asset_language_val
						? this.getRelatedLang(link.related_asset_language_val)
						: "",
					omniModule: link.related_asset_language_val
						? this.getStringBeforeUnderscore(
							link.related_asset_language_val
						)
						: "",
				}));
		},

		updateLanguageName(langCode) {
			switch (langCode) {
				case "en_US":
					return "English";
				case "fr_FR":
					return "Français";
				case "es_ES":
					return "Español";
				default:
					return undefined;
			}
		},
		getRelatedLang(str) {
			const arr = str.split("_");
			return arr.length > 1 ? arr[0] : "";
		},
		addProtocolIfMissing(url) {
			if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
				url = `https://${url}`;
			}
			return url;
		},
		getStringBeforeUnderscore(str) {
			const arr = str.split("_");
			const omniVal = `lang-${arr[0]}`;
			return arr.length > 1 ? omniVal : "";
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		this.langData = this.getassetrelation();
		this.pagelang = this.getPageLang;
		const currentLang = this.store.pagedata.omniture.s_language_locale.split("_")[0];
		const currentUrl = this.store.pagedata.omniture.s_pagename;

		if (Array.isArray(this.langData) && this.langData.length > 0) {
			// Existing implementation for related languages
			this.langData.forEach(language => {
				const lang = language.iso ? language.iso : '';
				const url = language.url ? language.url : '';
				if (lang && url) {
					this.store.cms.appendSeoAlternateTag({ lang, url })
				}
			});

			// Add current page's hreflang
			if (currentLang && currentUrl) {
				this.store.cms.appendSeoAlternateTag({
					lang: currentLang,
					url: this.addProtocolIfMissing(currentUrl)
				});
			}
		}
	},
};
</script>
<style lang="scss">
@import "stylesheets/main.scss";
</style>
